<template>
  <div class="content">
    <section>
      <h3>修改渠道</h3>
      <a class="close" @click="backPage"
        ><a-icon type="close-circle" style="font-size:26px;color:#666"
      /></a>
      <ul>
        <li v-if="changeChannelDetail != ''">
          <label>姓名：</label>
          <p>{{ changeChannelDetail.name }}</p>
        </li>
        <li v-if="changeChannelDetail != ''">
          <label>手机号：</label>
          <p>{{ changeChannelDetail.phone }}</p>
        </li>
        <li>
          <label><i>*</i>来源渠道：</label>
          <a-radio-group v-model="resume_source">
            <a-radio :value="2">芜湖招聘部</a-radio>
            <a-radio :value="3">玄鸟员工</a-radio>
            <a-radio :value="4">三方渠道</a-radio>
          </a-radio-group>
        </li>
        <li v-show="resume_source == 2">
          <label><i>*</i>来源账号：</label>
          <a-select
            style="width:200px"
            v-model="inviteVal"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              :value="element.id"
              v-for="(element, i) in inviteList"
              :key="i"
            >
              {{ element.user_name }}
            </a-select-option>
          </a-select>
        </li>
        <li v-show="resume_source == 3">
          <label><i>*</i>来源账号：</label>
          <a-select
            style="width:200px"
            v-model="userVal"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              :value="element.id"
              v-for="(element, i) in userList"
              :key="i"
            >
              {{ element.user_name }}
            </a-select-option>
          </a-select>
        </li>
        <li v-show="resume_source == 4">
          <label><i>*</i>来源三方：</label>
          <a-select
            style="width:200px"
            v-model="channelVal"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              :value="element.id"
              v-for="(element, i) in channelList"
              :key="i"
            >
              {{ element.name }}
            </a-select-option>
          </a-select>
        </li>
      </ul>
      <div class="submitStyle">
        <a-button type="primary" @click="onSubmit">提交</a-button>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      channelList: [],
      userList: [],
      resume_source: "",
      inviteList: "",
      inviteVal: "",
      userVal: "",
      channelVal: ""
    };
  },
  mounted() {
    this.getChannelList(); //获取三方渠道
    this.getUser(); //获取用户,
    this.getInvite(); //获取用户
  },
  props: {
    changeChannelDetail: {}
  },
  watch: {
    changeChannelDetail() {
      this.getChannelList(); //获取三方渠道
      this.getUser(); //获取用户,
      this.getInvite(); //获取用户,
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    verify() {
      let fls = true;
      if (this.resume_source == 2 && this.inviteVal == "") {
        fls = false;
        this.$message.error("请选择来源账号！");
        return fls;
      }
      if (this.resume_source == 3 && this.userVal == "") {
        fls = false;
        this.$message.error("请选择来源账号！");
        return fls;
      }
      if (this.resume_source == 4 && this.channelVal == "") {
        fls = false;
        this.$message.error("请选择三方渠道！");
        return fls;
      }
      return fls;
    },
    onSubmit() {
      let fls = this.verify();
      if (fls) {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.resume +
          "Resume_task/changeResumeSource";
        let userID = "";
        switch (this.resume_source) {
          case 2:
            userID = this.inviteVal;
            break;
          case 3:
            userID = this.userVal;
            break;
          case 4:
            userID = "";
            break;
        }
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          entry_id: this.changeChannelDetail.id,
          resume_source: this.resume_source,
          resume_third_part_id: this.channelVal,
          user_id: userID
        };
        if (this.resume_source != 4) {
          delete params.resume_third_part_id;
        } else {
          delete params.user_id;
        }
        // console.log(params);
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("更改成功");
            this.$emit("hideIsChangeChannel", true);
            this.resume_source = "";
            this.inviteVal = "";
            this.userVal = "";
            this.channelVal = "";
          } else {
            this.$message.error(res.data.code);
          }
        });
      }
    },
    backPage() {
      this.$emit("hideIsChangeChannel", false);
    },
    getInvite() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_task/getUserData";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        role_names: JSON.stringify(["招聘专员", "招聘组长"]),
        project_id: this.changeChannelDetail.project_id,
        job_status: 0
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.inviteList = res.data.data;
          // console.log(this.inviteList);
        }
      });
    },
    getUser() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_task/getUserData";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        role_names: JSON.stringify([
          "项目经理",
          "项目驻场",
          "项目总监",
          "自招团队"
        ]),
        project_id: this.changeChannelDetail.project_id,
        job_status: 0
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data;
          // console.log(this.userList);
        }
      });
    },
    getChannelList() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: this.changeChannelDetail.project_id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.channelList = res.data.data;
            // console.log(this.channelList);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  > section {
    background: #fff;
    width: 560px;
    margin: 100px auto;
    padding: 30px 0 30px 5%;
    border-radius: 10px;
    position: relative;
    h3 {
      font-size: 16px;
      text-align: center;
      margin: 30px 0;
      font-weight: normal;
    }
    .close {
      position: absolute;
      right: 10px;
      top: 10px;
    }
    > ul {
      > li {
        margin-bottom: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        i {
          color: red;
          font-style: normal;
          display: inline-block;
          margin-right: 6px;
        }
      }
    }
    .submitStyle {
      text-align: center;
      margin: 30px 0 10px;
    }
  }
}
</style>
